import { render, staticRenderFns } from "./CovidTestEntry.vue?vue&type=template&id=65789901&"
import script from "./CovidTestEntry.vue?vue&type=script&lang=js&"
export * from "./CovidTestEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports